module.exports = __webpack_public_path__ + "static/media/autoroulette.b1c8cf66.png";